import React, { Component } from 'react';
import parse from 'html-react-parser';
import styled from 'styled-components';

import mediaWidth from '../../../utils/mediaWidth/mediaWidth';
import color from '../../../utils/colors';
import api from '../../../services/api';

// import Paragraph from '../Paragraph';
// import LikeCounter from '../../LikeCounter';
import CloseButton from './CloseButton';
// import NavigationButton from './NavigationButton';

export default class FullSize extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: null,
        };

        this.getContent = this.getContent.bind(this);
    }

    componentDidMount() {
        const { id = 0 } = this.props;
        this.loadContent(id);
    }

    getContent(id) {
        this.setState({ content: null }, this.loadContent(id));
    }

    loadContent(id) {
        api.getCaseByID(id)
            .then(({ data }) => this.setState({ content: data }));
    }

    render() {
        const { content } = this.state;
        const {
            className, handleClosePopUp,
        } = this.props;

        return (
            <Root className={className}>
                <ContentContainer>
                    <ContentDesktopWrapper>
                        <StyledCloseButton onClick={handleClosePopUp} />
                        {/* <StyledLikeCounter onClick={() => console.log('click')} /> */}
                        {/* {
                            content.map(({ img, text }, i) => (
                                <Paragraph key={i.toString()} img={img} text={text} />
                            ))
                        } */}
                        { content ? parse(content.template) : null}
                        {/* <NavigationButtonsContainer>
                            <StyledNavigationButtonLeft
                                onClick={() => this.getContent(0)}
                            >
                                Предыдущее решение
                            </StyledNavigationButtonLeft>
                            <StyledNavigationButton
                                isNext
                                onClick={() => this.getContent(0)}
                            >
                                Следующее решение
                            </StyledNavigationButton>
                        </NavigationButtonsContainer> */}
                    </ContentDesktopWrapper>
                </ContentContainer>
            </Root>
        );
    }
}

// const NavigationButtonsContainer = styled.div`
//     margin-top: 40px;
//     margin-bottom: 48px;
//     display: flex;
//     justify-content: space-between;
// `;

const StyledCloseButton = styled(CloseButton)`
    position: absolute;
    top: -14px;
    right: 0;
`;

// const StyledLikeCounter = styled(LikeCounter)`
//     ${mediaWidth.l} {
//         position: absolute;
//         right: 1px;
//         top: 52px;

//         flex-direction: column;
//         div { margin-left: 0; }
//     }
// `;

const ContentContainer = styled.div`
    position: relative;
    width: 328px;

    ${mediaWidth.m} {
        width: 672px;
    };

    ${mediaWidth.l} {
        width: 864px;
    };

    ${mediaWidth.xl} {
        width: 1224px;
    };
`;

const ContentDesktopWrapper = styled.div`
    p {
        width: 328px;
    }

    img {
        width: 328px;
        height: 241px;
    }

    ${mediaWidth.m} {
        p {
            width: 672px;
    }

        img {
            width: 672px;
            height: 491px;
        }
    }

    ${mediaWidth.l} {
        width: 672px;
    }
`;

const Root = styled.div`
    width: 100%;
    padding: 24px 16px 0px;
    min-height: inherit;
    display: flex;
    justify-content: center;
    background-color: ${color.TEXT_SECONDARY};
    overflow-y: scroll;
`;

// const StyledNavigationButton = styled(NavigationButton)`
//     ${mediaWidth.m} {
//         width: 220px;
//         display: flex;
//         flex-direction: row-reverse;
//         align-items: baseline;
//         div { margin-right: 16px }
//     }
// `;

// const StyledNavigationButtonLeft = styled(NavigationButton)`
//     ${mediaWidth.m} {
//         width: 220px;
//         display: flex;
//         flex-direction: row;
//         align-items: baseline;
//         div { margin-left: 16px }
//     }
// `;
